<template>
  <div id="payment">
    <div class="main">
      <p class="page-title">{{ $t('payment.payment') }}</p>
      <div class="bg-white payment-tabs">
        <el-tabs v-model="activeName">
          <el-tab-pane label="Balance" name="balance"></el-tab-pane>
          <el-tab-pane label="Bank Card" name="bankCard"></el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="activeName === 'balance'" class="payment-methods f-c-c">
        <div class="payment-box bg-white">
          <div class="balance">
            <div>
              <span class="title">{{ $t('payment.availableBalance') }}</span>
              <div class="acount-box f--c">
                <span class="acount">$ {{ $store.state.common.balance }}</span>
                <el-button type="success" @click="dialogVisible = true" round>{{ $t('payment.topUp') }}</el-button>
              </div>
            </div>
          </div>
          <!-- 2025.11.07 40seas支付 去掉 -->
          <!-- <div class="used">
            <div>
              <h3>{{ $t('PersonalCenter.Payment.Index.AvailableCredit') }}</h3>
              <p>40Seas: US$ {{ info40Seas.availableCredit ? info40Seas.availableCredit : 0 }}</p>
              <p v-if="creditInfo.creditLimit">Kaka: US$ {{ usableQuota(creditInfo.creditLimit, creditInfo.usedLimit) }}</p>
            </div>
          </div>

          <div class="credit">
            <div>
              <h3>{{ $t('PersonalCenter.Payment.Index.CreditLimit') }}</h3>
              <p v-if="info40Seas.status === 'approved'">40Seas: US$ {{ info40Seas.creditLimit ? info40Seas.creditLimit : 0 }}</p>
              <p v-else-if="['pending', 'manual review'].includes(info40Seas.status)">40Seas: US$ {{ info40Seas.creditLimit ? info40Seas.creditLimit : 0 }} <span style="font-size:20px;color:#C0C4CC">({{ $t('Index.PaymentPage.UnderReview') }})</span></p>
              <p v-else-if="info40Seas.status === 'declined'">40Seas: US$ 0 <span style="color:#C0C4CC;font-size:20px">({{ $t('Index.PaymentPage.AuditRejected') }})</span></p>
              <p v-else>40Seas: US$ 0<span style="font-size:20px;color:#518EFF;text-decoration:underline;padding-left:6px;cursor: pointer;" @click="applyNow()"> {{ $t('Index.PaymentPage.ApplyNow') }}</span></p>
              <p v-if="creditInfo.creditLimit">Kaka: US$ {{ creditInfo.creditLimit ? creditInfo.creditLimit : 0 }}</p>
            </div>
          </div> -->
        </div>
      </div>
      <div v-if="activeName === 'balance'" class="transactions bg-white">
        <h6>{{ $t('payment.transactions') }}</h6>
        <div class="payment-list">
          <div class="filter-head">
            <el-select clearable v-model="listForm.paymentMethod" :placeholder="$t('payment.paymentMethods')" style="max-width: 178px; margin-right: 15px" @change="handleChange">
              <el-option v-for="item in paymentMethods" :key="item.value" :label="item.name" :value="item.value">
                {{ item.name }}
              </el-option>
            </el-select>
            <el-select clearable v-model="listForm.paymentType" :placeholder="$t('payment.allType')" style="max-width: 128px; margin-right: 15px" @change="handleChange">
              <el-option v-for="item in transType" :key="item.value" :label="item.name" :value="item.value">{{ item.name }}</el-option>
            </el-select>
            <el-select clearable v-model="listForm.incomeType" :placeholder="$t('payment.transactions')" style="max-width: 178px; margin-right: 15px" @change="handleChange">
              <el-option v-for="item in transaction" :key="item.value" :label="item.name" :value="item.value"> {{ item.name }}</el-option>
            </el-select>
            <el-date-picker :default-time="['00:00:00', '23:59:59']" class="timepicker" v-model="value" placement="bottom-start" value-format="timestamp" @change="handleTimeChange" clearable type="daterange" range-separator="-" :start-placeholder="$t('payment.startDate')" :end-placeholder="$t('payment.endDate')"></el-date-picker>
            <el-input prefix-icon="el-icon-search" placeholder="Order ids" v-model="listForm.kkOrderIds" @change="handleChange" style="max-width: 200px" clearable></el-input>
            <span class="export-icon pointer" @click="exportPayment"><i class="iconfont icon-a-download-2-line3"></i>{{ $t('payment.export') }}</span>
          </div>

          <div :class="['table-box', {'no-data': total >= 20}]">
            <el-table :data="transactionList" style="width: 100%" :header-cell-style="tableRowClassName" height="100%">
              <template slot="empty">
                <img src="@/assets/img/homePage/empty-data.svg" alt="" />
                <p>{{ $t('PersonalCenter.Payment.Index.Tips1') }}</p>
              </template>
              <el-table-column prop="completionTime" :label="$t('payment.transactionTime')" min-width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.completionTime | dateFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="paymentId" :label="$t('payment.orderNumber')" min-width="150">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.kkOrders" :key="index">{{ item.kkOrderId }}</div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('payment.type')" min-width="100">
                <template slot-scope="scope">
                  <span>{{ getPaymentType(scope.row.paymentType) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="amount" :label="$t('payment.amount')" width="120">
                <template slot-scope="scope">
                  <span :style="{ color: scope.row.incomeType === 0 ? '#A6100C' : '#99c41c' }">{{ scope.row.incomeType === 0 ? '-' : '+' }} US$ {{ scope.row.amount }} </span>
                </template>
              </el-table-column>
              <el-table-column prop="paymentMethod" :label="$t('payment.paymentMethods')" width="150">
                <template slot-scope="scope">
                  <span>{{ getPaymentMethod(scope.row.paymentMethod) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Notes" min-width="150">
                <template v-slot="{ row }">
                  {{ row.note ? row.note : '-' }}
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="total >= 20" class="f-e" style="margin: 16px 30px 0 0">
            <el-pagination background layout="total,sizes,prev, pager, next" :total="total" :page-sizes="[20, 30, 40, 50]" :current-page.sync="listForm.pageNumber" :page-size="listForm.pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
          </div>
        </div>
      </div>
      <bank-card v-if="activeName === 'bankCard'" />
    </div>
    <el-dialog :title="$t('payment.topUp')" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="topUpForm" label-position="top" :model="topUpForm" :rules="rules">
        <el-form-item :label="$t('payment.enterAmount')" prop="amount"> <el-input style="width: 300px" v-model="topUpForm.amount"></el-input> USD </el-form-item>
        <el-form-item :label="$t('payment.paymentMethods')">
          <el-radio-group v-model="topUpForm.paymentMethod">
            <!-- <el-radio label="1">Oceanpayment</el-radio> -->
            <el-radio label="2">{{ $t('PersonalCenter.Payment.Index.Paypal') }}</el-radio>
            <!-- <el-radio v-if="$store.state.common.userGroup === 100" label="4">{{ $t('orderList.CreditCard') }}</el-radio>
            <el-radio v-else label="9">{{ $t('orderList.CreditCard') }}</el-radio> -->
            <!-- 2025.06.09 信用卡逻辑调整 全部用空中云汇的（陈琼瑜） -->
            <el-radio label="4">{{ $t('orderList.CreditCard') }}</el-radio>
            <el-radio label="3">{{ $t('PersonalCenter.Payment.Index.Others') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="handleTopUp">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <QianHai ref="qianhai" @success="paySuccess" @fail="payFail" />
    <Paypal ref="paypal" @success="paySuccess" @fail="payFail" />
    <Airwallex ref="airwallex" :payCallbackUrl="location.href" @success="paySuccess" @fail="payFail" />
    <Payoneer ref="payoneer" :payCallbackUrl="`${location.origin}/personal-center/payment-manage`" @payoneerError="handlePayoneerError"/>
    <AddressDialog ref="addressdialog" :addForm="addressForm"  @submitForm="getAddressList"></AddressDialog>
  </div>
</template>

<script>
import axios from 'axios'
import QianHai from '@/components/QianHai.vue'
import Paypal from '@/components/Paypal.vue'
import Airwallex from '@/components/Airwallex.vue'
import Payoneer from '@/components/Payoneer.vue'
import { amount } from '@/util/validate'
import AddressDialog from '@/views/commodity/components/AddressDialog'
import XLSX from 'xlsx'
import { downloadBlobFile } from '@/util/index'
import API from '@/api'
import BankCard from './bankCard.vue'
// import _ from 'lodash'
let validAmount = (rules, value, callback) => {
  if (amount(value)) {
    callback()
  } else {
    callback(new Error(`${this.$t('PersonalCenter.Payment.Index.Tips2')}`))
  }
}
export default {
  components: { QianHai, Paypal, Airwallex, BankCard, Payoneer, AddressDialog },
  data() {
    return {
      listForm: {
        pageSize: 20,
        pageNumber: 1
        // completionTimeStart: 1,
        // completionTimeEnd: 1
      },
      topUpForm: {
        paymentMethod: '2'
      },
      location: window.location,
      rules: {
        amount: [
          { required: true, message: this.$t('common.pleaseEnter'), trigger: 'blur' },
          { validator: validAmount, trigger: 'blur' }
        ]
      },
      transType: [
        { name: this.$t('payment.refund'), value: -1 },
        { name: this.$t('payment.purchase'), value: 0 },
        { name: this.$t('payment.dropshipping'), value: 1 },
        { name: this.$t('payment.sample'), value: 2 },
        { name: this.$t('payment.topUp'), value: 3 },
        { name: this.$t('payment.orderDeposit'), value: 4 },
        { name: this.$t('payment.orderBalance'), value: 5 },
        { name: 'Bill', value: 7 }
      ],
      paymentMethods: [
        { name: this.$t('payment.balance'), value: 0 },
        { name: this.$t('payment.creditCard'), value: 1 },
        { name: 'Paypal', value: 2 },
        { name: 'Airwallex', value: 3 },
        { name: 'KakaClo', value: 4 },
        { name: 'Gift Card', value: 5 },
        { name: 'Credit', value: 6 },
        { name: 'Authorized', value: 7 },
        { name: '40Seas', value: 8 },
        { name: 'Payoneer', value: 9 }
      ],
      transaction: [
        { name: this.$t('payment.income'), value: 1 },
        { name: this.$t('payment.expenditure'), value: 0 }
      ],
      creditCards: [],
      transactionList: [],
      total: 0,
      value: '',
      value1: '',
      dialogVisible: false,
      exportForm: {},

      activeName: 'balance',

      creditInfo: {
        creditLimit: undefined,
        usedLimit: undefined
      },

      info40Seas: {
        creditLimit: undefined,
        availableCredit: undefined
      },
      addressForm: {
        fullName: undefined,
        phoneNumber: undefined,
        streetAddressLine1: undefined,
        streetAddressLine2: undefined,
        city: undefined,
        province: undefined,
        countryCode: undefined,
        zipCode: undefined,
        vatCode: undefined
      }
    }
  },
  computed: {
    /**
     * 计算可用额度
     */
    usableQuota() {
      return (creditLimit, usedLimit) => {
        return creditLimit && (usedLimit || usedLimit === 0) ? (creditLimit - usedLimit < 0 ? 0 : (creditLimit - usedLimit).toFixed(2)) : 0
      }
    },

    getPaymentMethod() {
      return (methods) => {
        switch (methods) {
          case 0:
            return this.$t('payment.balance')
          case 1:
            return this.$t('payment.creditCard')
          case 2:
            return 'Paypal'
          case 3:
            return 'Airwallex'
          case 4:
            return 'KakaClo' // this.$t('payment.systemTopup')
          case 5:
            return this.$t('payment.giftCard')
          case 6:
            return 'Credit'
          case 7:
            return 'Authorized'
          case 8:
            return '40Seas'
          case 9:
            return 'Payoneer'
          default:
            return '-'
        }
      }
    },
    getPaymentType() {
      return (paymentType) => {
        switch (paymentType) {
          case -1:
            return this.$t('payment.refund')
          case 0:
            return this.$t('payment.purchase')
          case 1:
            return this.$t('payment.dropshipping')
          case 2:
            return this.$t('payment.sample')
          case 3:
            return this.$t('payment.topUp')
          case 4:
            return this.$t('payment.orderDeposit')
          case 5:
            return this.$t('payment.orderBalance')
          case 7:
            return 'Bill'
          default:
            return '-'
        }
      }
    }
  },
  created() {
    if (this.$route.query.type === 'bank_card') {
      this.$set(this.$data, 'activeName', 'bankCard')
      return
    }
    this.getTransactions()
    this.$store.dispatch('common/getBalance')

    this.getCreditUserInfo()
    this.payment40SeasBuyerCreditline()
  },
  mounted() {
    if (this.$route.query.interactionCode === 'ABORT') {
      this.$message.error(`Payment Fail: ${this.$route.query.interactionReason}`)
    }
    if (this.$route.query.interactionCode) {
      this.$nextTick(() => {
        this.$router.replace({ query: {}})
      })
    }
  },
  methods: {
    /**
     * API 查询当前用户信用信息
     */
    async getCreditUserInfo() {
      let { data } = await API.getCreditUserInfo()
      if (data) {
        this.creditInfo.creditLimit = data.creditLimit // 信用额度
        this.creditInfo.usedLimit = data.usedLimit // 已使用额度
      }
    },

    exportPayment() {
      this.exportForm = {
        paymentType: this.listForm.paymentType,
        incomeType: this.listForm.incomeType,
        paymentMethod: this.listForm.paymentMethod,
        kkOrderIds: this.listForm.kkOrderIds
      }
      if (this.listForm.completionTimeStart) {
        this.exportForm.completionTimeStart = this.listForm.completionTimeStart
      }
      if (this.listForm.completionTimeEnd) {
        this.exportForm.completionTimeEnd = this.listForm.completionTimeEnd
      }
      axios({
        url: '/api/payment/transactionsExport',
        params: this.exportForm,
        headers: { Authorization: `Bearer ${this.$store.state.common.token}` }
      })
        .then((res) => {
          if (res.data) {
            let array = res.data.split(/[\n]/)
            const result = []
            array.pop()
            array.forEach((item) => {
              result.push(item.split(','))
            })
            var sheet = XLSX.utils.aoa_to_sheet(result)
            downloadBlobFile(this.sheet2blob(sheet), 'Transaction.xlsx')
          }
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    sheet2blob(sheet, sheetName) {
      sheetName = sheetName || 'sheet1'
      var workbook = {
        SheetNames: [sheetName],
        Sheets: {}
      }
      workbook.Sheets[sheetName] = sheet
      // 生成excel的配置项
      var wopts = {
        bookType: 'xlsx', // 要生成的文件类型
        bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: 'binary'
      }
      var wbout = XLSX.write(workbook, wopts)
      var blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
      function s2ab(s) {
        var buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }
      return blob
    },
    getTransactions() {
      API.getTransactions(this.listForm)
        .then((result) => {
          this.transactionList = result.data.list
          this.total = result.data.total
        })
        .catch((result) => {
          this.$message.error(result.data.message || result.message)
        })
    },
    formateTime(str) {
      var oDate = new Date(str)
      var oYear = oDate.getFullYear()
      var oMonth = oDate.getMonth() + 1
      var oDay = oDate.getDate()
      var oHour = oDate.getHours()
      var oMin = oDate.getMinutes()
      var oSec = oDate.getSeconds()
      var oTime = ''
      oTime = oYear + '-' + this.getzf(oMonth) + '-' + this.getzf(oDay) + ' ' + this.getzf(oHour) + ':' + this.getzf(oMin) + ':' + this.getzf(oSec) // 最后拼接时间
      return oTime
    },
    // 补0操作
    getzf(num) {
      if (parseInt(num) < 10) {
        num = '0' + num
      }
      return num
    },
    handleChange(value) {
      this.listForm.pageNumber = 1
      this.getTransactions()
    },
    handleSizeChange(val) {
      this.listForm.pageSize = val
      this.getTransactions()
    },
    handleCurrentChange(val) {
      this.listForm.pageNumber = val
      this.getTransactions()
    },
    /**
     * 创建交易单
     * amount 订单总金额
     * paymentMethod  支付方式
     * address {Object} 收货地址对象
     */
    createTransactionOrder(amount, paymentMethod, address) {
      API.createTransactionOrder({
        amount,
        paymentMethod: +paymentMethod === 4 ? 3 : paymentMethod,
        currencyCode: 'USD',
        paymentType: 3
      })
        .then((result) => {
          this.transactionOrderId = result.data
          switch (+paymentMethod) {
            case 1:
              this.$refs.qianhai.show({
                order_number: result.data, // 订单号
                order_amount: amount, // 交易金额
                billing_lastName: address.fullName, // 持卡人名
                billing_firstName: address.fullName, // 持卡人姓
                billing_email: this.$store.state.common.email, // 持卡人邮箱
                billing_country: address.countryCode, // 持卡人国家
                billing_state: address.province, // 持卡人州/省
                billing_city: address.city, // 持卡人城市
                billing_address: address.streetAddressLine1, // 持卡人地址
                billing_zip: address.zipCode, // 持卡人邮编
                productName: 'ksdjflkas', // 产品名称
                productNum: 1, // 数量
                productSku: 'kjasdfl'
              })
              break
            case 2:
              this.$refs.paypal.show(result.data)
              break
            case 3:
              this.$refs.airwallex.show(result.data, ['wechatpay', 'alipaycn'])
              break
            case 4:
              this.$refs.airwallex.show(result.data, ['card'])
              break
            case 9:
              this.$refs.payoneer.show(result.data)
              break
          }
        })
        .catch((response) => {
          this.$message.error(response.data.message)
        })
    },
    handleTopUp() {
      this.$refs.topUpForm.validate((valid) => {
        if (!valid) return
        this.dialogVisible = false
        if (this.topUpForm.paymentMethod === '1') {
          const addressList = this.$store.state.common.addressList
          if (addressList.length === 0) return this.$message.info(this.$t('promptText.msg41'))
          this.createTransactionOrder(this.topUpForm.amount, this.topUpForm.paymentMethod, addressList[0])
        } else {
          this.createTransactionOrder(this.topUpForm.amount, this.topUpForm.paymentMethod)
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.topUpForm.amount = undefined
      this.topUpForm.paymentMethod = '1'
    },
    tableRowClassName() {
      return 'background-color:rgba(0, 0, 0, 0.02);font-size:14px;font-weight:500;color:#10141d;'
    },
    manageCreditCards() {},
    handleTimeChange(value) {
      if (value && value.length > 0) {
        this.listForm.completionTimeStart = value[0]
        this.listForm.completionTimeEnd = value[1]
      } else {
        delete this.listForm.completionTimeStart
        delete this.listForm.completionTimeEnd
      }
      this.listForm.pageNumber = 1
      this.getTransactions()
    },
    paySuccess() {
      this.$message.success(this.$t('msg.success'))
      this.$store.dispatch('common/getBalance')
      this.getTransactions()
    },
    payFail(message) {
      this.$message.error(message || 'Recharge failed')
    },
    // 参数拼接
    params(obj) {
      let result = ''
      let item
      for (item in obj) {
        if (obj[item] && String(obj[item])) {
          result += `&${item}=${obj[item]}`
        }
      }
      if (result) {
        result = '?' + result.slice(1)
      }
      return result
    },
    // 40seas-获取用户信用额度
    payment40SeasBuyerCreditline() {
      API.payment40SeasBuyerCreditline().then(res => {
        if (res.code === 10000 && res.data) {
          this.info40Seas = res.data
        }
      })
    },
    // 申请40seas
    applyNow() {
      API.payment40SeasBuyer().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        window._40Seas.open(res.data.token, {
          onCancel: () => {
            window._40Seas.close()
          }
        })
      })
    },
    // 未发现账单地址接口返回错误时
    handlePayoneerError() {
      let params = { type: 1 }
      let newParams = { ...this.AddAddressForm, ...params }
      this.$set(this, 'addressForm', newParams)
      this.$refs.addressdialog.show(true)
    },
    // 提交关闭地址弹框
    getAddressList(address) {
      this.$refs.addressdialog._data.dialogVisible = false
      this.$refs.addressdialog._data.loading = false
      // this.$store.dispatch('common/getAddressList')
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-tabs {
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
  /deep/ .el-tabs__nav-scroll {
    padding-left: 40px;
  }
}

.table-box {
  height: calc(100vh - 450px + 48px);
  &.no-data {
    height: calc(100vh - 440px);
  }
  /deep/.el-table__empty-text {
    line-height: 36px;
  }
}
#payment {
  font-family: Arial;
  margin: 18px 0 0 0;
}

.payment-methods {
  margin-bottom: 10px;
}

// .payment-box {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   width: 100%;
//   height: 118px;
//   padding: 0 26px;
//   .title {
//     display: inline-block;
//     font-size: 16px;
//     line-height: 24px;
//     padding-bottom: 10px;
//   }
//   .used,
//   .credit {
//     position: relative;
//     display: flex;
//     height: 100%;
//     padding-left: 128px;
//     flex-direction: column;
//     justify-content: center;
//     h3 {
//       color: #000000;
//       font-weight: 500;
//       font-size: 16px;
//       line-height: 24px;
//     }
//     p {
//       color: #000000;
//       font-weight: 500;
//       font-size: 26px;
//       line-height: 39px;
//     }
//     .line {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 1px;
//     }
//   }
//   .used {
//     .line {
//       height: 100%;
//       background: #eff1f3;
//       box-shadow: 0px 4px 14px 6px rgba(205, 212, 221, 0.1);
//     }
//   }
//   .credit {
//     .line {
//       top: 50%;
//       height: 39px;
//       transform: translateY(-50%);
//       background-color: #c4c4c4;
//     }
//   }
// }

.payment-box {
  display: flex;
  width: 100%;
  height: 140px;
  padding: 0 20px;
  align-items: center;
  justify-content: space-between;

  .balance,
  .used,
  .credit {
    display: flex;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .used,
  .credit {
    box-shadow: -12px 0px 10px 0px rgba(205, 212, 221, 0.1);
    h3 {
      color: #000;
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      margin-bottom: 10px;
    }
    p {
      color: #000;
      font-size: 24px;
      font-weight: 500;
      line-height: 39px;
    }
  }

  .balance {
    flex: 3;
    .title {
      display: inline-block;
      font-size: 16px;
      line-height: 24px;
      padding-bottom: 10px;
    }
  }
  .used {
    flex: 4;
  }

  .credit {
    flex: 4;
  }
}

.page-title {
  display: inline-block;
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  padding-bottom: 10px;
  padding-left: 20px;
}
/deep/.el-button--success {
  border-color: none;
  border: none;
  background: #99c41c;
}
.transactions {
  h6 {
    height: 53px;
    line-height: 53px;
    font-size: 14px;
    font-weight: 500;
    color: #10141d;
    padding-left: 28px;
    border-bottom: 0.5px solid #cdd4dd;
  }
}
.payment-list {
  padding: 15px 20px;
}
.filter-head {
  min-width: 800px;
  margin-bottom: 20px;
}
.table {
  font-size: 12px;
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
/deep/.el-form-item__label {
  padding-bottom: 5px;
  line-height: 30px;
}
/deep/.el-input__inner {
  // height: 36px;
  border-radius: 40px;
}
/deep/.el-radio {
  padding-bottom: 10px;
}
/deep/.is-error {
  margin-bottom: 20px;
}
/deep/.el-dialog__body {
  padding: 10px 30px;
}
.export-icon {
  color: #99c41c;
  font-size: 14px;
  float: right;
  line-height: 36px;
}
.acount {
  font-size: 26px;
  line-height: 39px;
  font-weight: 500;
  // margin-right: 50px;
  margin-right: 18px;
}
.credit-card {
  margin-bottom: 15px;
}
.card {
  padding: 11px 32px;
  margin-bottom: 10px;
  border: 0.5px solid #8b93a3;
  box-sizing: border-box;
  border-radius: 6px;
}
.card-font {
  font-size: 14px;
  line-height: 20px;
}
.card-number {
  font-size: 26px;
  line-height: 37px;
  color: #10141d;
  padding: 7px 0 16px 0;
  font-family: Alte DIN 1451 Mittelschrift gepraegt;
}
.delete-card {
  font-size: 14px;
  line-height: 20px;
  color: #99c41c;
}
.add-card {
  width: 100%;
  height: 43px;
  border: 1px dashed #cdd4dd;
  box-sizing: border-box;
  border-radius: 6px;
}
.btg-group {
  margin-top: 35px;
}
.timepicker {
  max-width: 320px;
  height: 36px;
  margin-right: 15px;
}
</style>
